import React from 'react';
import {Button, Card, Dropdown, Space, Tag, Typography} from 'antd';
import {CloseOutlined, PlusOutlined} from '@ant-design/icons';
import dayjs from 'dayjs';
import LevelRangeCondition from './LevelRangeCondition';
import RegistrationDateCondition from './RegistrationDateCondition';

// 새 조건 타입 추가 시 여기에만 등록
export const CONDITION_REGISTRY = {
    level_range: {
        label: '레벨 범위',
        component: LevelRangeCondition,
        defaultParams: {min: 1, max: 100},
    },
    registration_date: {
        label: '계정 생성일 기준',
        component: RegistrationDateCondition,
        defaultParams: {
            start: dayjs().startOf('day').unix(),
            end: dayjs().endOf('day').unix(),
        },
    },
};

const ConditionPanel = ({conditions, onChange}) => {
    const usedTypes = conditions.map(c => c.type);

    const addCondition = (type) => {
        if (usedTypes.includes(type)) return;
        onChange([...conditions, {type, params: {...CONDITION_REGISTRY[type].defaultParams}}]);
    };

    const removeCondition = (type) => {
        onChange(conditions.filter(c => c.type !== type));
    };

    const updateParams = (type, params) => {
        onChange(conditions.map(c => c.type === type ? {...c, params} : c));
    };

    const menuItems = Object.entries(CONDITION_REGISTRY)
        .filter(([type]) => !usedTypes.includes(type))
        .map(([type, {label}]) => ({key: type, label}));

    return (
        <Space direction="vertical" style={{width: '100%'}}>
            <Space align="center">
                <Typography.Text strong>발송 조건</Typography.Text>
                <Dropdown
                    menu={{items: menuItems, onClick: ({key}) => addCondition(key)}}
                    disabled={menuItems.length === 0}
                >
                    <Button size="small" icon={<PlusOutlined/>}>조건 추가</Button>
                </Dropdown>
                {conditions.length === 0 && (
                    <Tag color="green">조건 없음 (전체 유저)</Tag>
                )}
            </Space>

            {conditions.map(({type, params}) => {
                const def = CONDITION_REGISTRY[type];
                if (!def) return null;
                const Component = def.component;
                return (
                    <Card
                        key={type}
                        size="small"
                        title={def.label}
                        extra={
                            <CloseOutlined
                                style={{cursor: 'pointer', color: '#999'}}
                                onClick={() => removeCondition(type)}
                            />
                        }
                        style={{width: '100%'}}
                    >
                        <Component params={params} onChange={p => updateParams(type, p)}/>
                    </Card>
                );
            })}
        </Space>
    );
};

export default ConditionPanel;